'use client';

/**
 * api-client.ts — shim legacy (Estrategia A, SPEC-244 §4).
 *
 * Este archivo era originalmente de 9.614 líneas y ha sido particionado
 * en módulos ≤1.000 L bajo `./api-client/` (SPEC-244 IA17).
 *
 * API pública inmutable: este shim re-exporta todo lo que el archivo
 * original exportaba, así los consumers no cambian sus imports:
 *
 *   import { api, apiFetch, tokenStore, ApiClientError } from '@/lib/api-client';
 *
 * Pendiente (#IA17-1): shim removal sprint+1 (patrón #CPN-1/#H-1/#F-1/#AIPRO-1/#MARKET-1/#ADMIN-1).
 *
 * Part of SPEC-244 IA17 split (refactor/spec244-ia17-api-client).
 */

// Re-export everything from the new modular api-client/ directory.
// Note: './api-client/index' is the explicit path to avoid self-reference
// (this file is also called api-client.ts).
//
// HOTFIX (2026-10-05): este archivo tenía marcadores de merge conflict
// SIN RESOLVER commiteados (HEAD vs c12803dff) desde el merge #1179
// "SPEC-244 IA split (final rebase)" — el commit IA17 38449e29b ya contenía
// el blob conflictuado de 9.660 L en vez del shim de 22 L que su mensaje
// describe. Eso rompía `tsc` (TS1185) → el build del frontend → CUALQUIER
// deploy. Restaurado al shim intencional del split (export * del barrel,
// contenido según el lado c12803dff del conflicto).
export * from './api-client/index';
